import { render, staticRenderFns } from "./TicketsCustom.vue?vue&type=template&id=03ff5ebc&"
import script from "./TicketsCustom.vue?vue&type=script&lang=js&"
export * from "./TicketsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports